<template>
<div>
    <div class="mcc-page-header">
        <div class="mu-d-flex mu-flex-column mu-w-100 mu-gap-04">
            <div class="mu-d-flex mu-justify-content-between mu-align-items-center mu-flex-wrap">
                <section class="mu-d-flex mu-flex-row mu-w-100">

                    <h1 class="mu-mb-00">Definitions</h1>
                    <details class="mcc-popover mcc-popover--bottom-end">
                        <summary class="mcc-button mcc-button--icon-only ">
                            <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                        </summary>
                        <div class="mcc-popover__content">

                            <p class="mu-mb-00">
                                {{ helpText.title }}
                                <a :href="helpText.url" target="_blank">Read more...</a>
                            </p>
                        </div>
                    </details>

                </section>
            </div>

        </div>
    </div>
    <div class="mcc-container--fluid card-padding">
        <div>
            <nav aria-label="breadcrumb" class="">
                <ol class="mcc-breadcrumb">
                    <li>Process engine</li>
                    <li>Definitions</li>
                </ol>
            </nav>
        </div>
        <div class="mcc-card mu-p-06">
            <div class="mcc-row" v-if="!fetchCall">
                <div class="mcc-col colSpinner">
                    <div class="spinner-overlay">
                        <div class="spinner-background"></div>
                        <div class="spinner-flex">
                            <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            </svg>
                        </div>
                    </div>

                </div>

            </div>
            <div class="mcc-row" v-if="fetchCall">
                <div class="mcc-col">
                    <div style="position:relative">
                        <div v-if="!updateCall" class="spinner-overlay">
                            <div class="spinner-background"></div>
                            <div class="spinner-flex">
                                <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                    <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                    <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                </svg>
                            </div>
                        </div>

                        <Drawer ref="customFilter" @reset-filter="resetFilter" @apply-filter="filterTable" title="Definition Filters">
                          
                                <section>
                                    <form id="formIdd">
                                    <div>
                                        <div class="mcc-row">
                                            <div class="mcc-col ">
                                                <div class="mfc-input-wrapper mu-d-block mfc-form-input-container drawer-input">
                                                    <label for="processKey">Key</label>
                                                    <input type="text" name="processKey" maxlength="100" id="processKey" :value="keyRef" @change="keyRef = $event.target.value">

                                                </div>
                                                <div class="mfc-input-wrapper mu-d-block mfc-form-input-container drawer-input">
                                                    <label for="processName">Name</label>
                                                    <input type="text" name="processName" maxlength="50" id="processName" :pattern="nameRegex" :value="defNameRef" @change="defNameRef = $event.target.value">

                                                </div>
                                                <div class="mfc-slim-select-wrapper drawer-input">
                                                    <label for="category">Category</label>
                                                    <select id="category" class="mfc-slim-select" aria-label="single_radio_input" @change="categoryRef = $event.target.value" name="category" block>
                                                        <option data-placeholder="true" value :selected="categoryRef ==''">All</option>
                                                        <option v-for="(app,key) in categoryList" :selected="categoryRef == app.name" :key="key" :value="app.name">{{app.name}}</option>
                                                    </select>
                                                </div>
                                                <div class="mfc-slim-select-wrapper drawer-input">
                                                    <label for="startableByUser">Startable by user</label>
                                                    <select class="mfc-slim-select" aria-label="single_radio_input" @change="startableByRef = $event.target.value" name="startableByUser" id="startableByUser" block>
                                                        <option data-placeholder="true" value :selected="startableByRef ==''"></option>
                                                        <option v-for="(user,key) in allUsers" :selected="startableByRef == user.username" :key="key" :value="user.username">{{user.firstName}} {{user.surname}}</option>
                                                    </select>
                                                </div>
                                                <div class=" mcc-segmented-buttons drawer-input">
                                                    <fieldset class="mfc-fieldset mcc-segmented-buttons--sm" aria-required="true" role="radiogroup" help-text size="sm" :value="suspendedRef" @change="suspendedRef = $event.target.value" label="Suspended" block name="suspended" id="suspended">
                                                        <legend class="mfc-label">
                                                            Suspended
                                                        </legend>
                                                        <div class="mcc-segmented-buttons__list">
                                                            <input type="checkbox" name="suspend_button1" id="suspend_button1" value="yes" :checked="suspendedRef==='yes'">
                                                            <label class="mcc-segmented-buttons__button" for="suspend_button1">
                                                                <span class="mcc-segmented-buttons__label">Yes</span>
                                                            </label>
                                                            <input type="checkbox" name="suspend_button2" id="suspend_button2" value="no" :checked="suspendedRef==='no'">
                                                            <label class="mcc-segmented-buttons__button" for="suspend_button2">

                                                                <span class="mcc-segmented-buttons__label">No</span>
                                                            </label>
                                                            <input type="checkbox" name="suspend_button3" id="suspend_button3" value="all" :checked="suspendedRef==='all'">
                                                            <label class="mcc-segmented-buttons__button" for="suspend_button3">

                                                                <span class="mcc-segmented-buttons__label">All</span>
                                                            </label>
                                                        </div>
                                                    </fieldset>
                                                </div>
                                            </div>

                                                </div>
                                            </div>
                                        </form>
                                        </section>
                                   
                                </Drawer>
                                <div class="mu-d-flex mu-justify-content-end mu-pb-06">
                                    <button class="mcc-button mcc-button--outline  mcc-button--sm" @click="$refs.customFilter.open()">
                                        <mcc-icon name="filter" aria-hidden="true"></mcc-icon>
                                        <span class="mcc-button__label">Filters {{filterCount > 0 ? ` (${filterCount})` : '(1)'}}</span>
                                    </button>
                                </div>
                                <mcc-data-table ref="defTable" id="defTableId"></mcc-data-table>
                            </div>

                </div>
            </div>

        </div>

    </div>
</div>
</template>

<script>
import constantMessages from "../../../messages";
import DefinitionAPI from '../../../services/DefinitionAPI';
import Utils from "@/script_utils";
import axios from 'axios';
import Drawer from "../../common/Drawer.vue";
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage
} from '../../../formvalid.js';
export default {
    name: "DefinitionsList",
    components: {
        Drawer

    },
    data() {
        return {
            helpText: constantMessages.BREADCRUMB_HELP["processengine.processdefinitions.list"],
            nameRegex: constantMessages.PATTERNS["name"],
            showHelpText: false,
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            definitions: {},
            updateDialog: false,
            defName: "",
            defNameRef: "",
            key: "",
            keyRef: "",
            suspendedType: "all",
            suspendedRef: "all",
            startableBy: "",
            startableByRef: "",
            category: "",
            categoryList: {},
            allUsers: {},
            categoryRef: "",
            tableObj: null,
            currentPageSize: 10,
            fetchCall: false,
            updateCall: true,
            filterCount: 0,
            tableData: [],
            categorySlimIntsance: null,
            startableByUserSlimInstance: null,
        };
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);
        let self = this;
        let processDefinitionCategory = localStorage.getItem("processDefinitionCategory");
        if (processDefinitionCategory != null && processDefinitionCategory != "") {
            this.category = processDefinitionCategory;
            this.categoryRef = processDefinitionCategory;
            this.filterCount = parseInt(localStorage.getItem("setFilterDataInLocalStorage"));
            localStorage.removeItem("processDefinitionCategory");
        }
        if (localStorage.getItem("definitionlist") === "definitionlist") {
            let storedKey = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_key"
            );

            if (storedKey != null) {
                this.key = storedKey;
                this.keyRef = storedKey;
            }
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_key"
            );

            let storedDef = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_defName"
            );

            if (storedDef != null) {
                this.defName = storedDef;
                this.defNameRef = storedDef;
            }

            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_defName"
            );

            let storedCategory = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_category"
            );

            if (storedCategory != null) {
                this.category = storedCategory;
                this.categoryRef = storedCategory;
            }

            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_category"
            );

            let storedStartedBy = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_startableBy"
            );
            if (storedStartedBy != null) {
                this.startableBy = storedStartedBy;
                this.startableByRef = storedStartedBy;
            }
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_startableBy"
            );

            let storedSuspendedType = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_suspendedType"
            );
            if (storedSuspendedType != null) {
                this.suspendedType = storedSuspendedType;
                this.suspendedRef = storedSuspendedType;
            }
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_suspendedType"
            );

            let storedPageSize = localStorage.getItem("definitionlistPageSize");
            if (storedPageSize != null && storedPageSize != "") {
                this.currentPageSize = parseInt(
                    storedPageSize
                );
            }
            localStorage.removeItem("definitionlistPageSize");

            localStorage.removeItem("definitionlist");

        }

        axios.all([
            DefinitionAPI.getCategories(),
            DefinitionAPI.getAllUsers(),
        ]).then(responseArr => {
            self.categoryList = responseArr[0].data;
            self.allUsers = responseArr[1];
            self.fetchCall = true;

        }).finally(() => {
            this.$nextTick(() => {
                self.initDefTable();
                this.categorySlimIntsance = new SlimSelect({
                    select: '#category',
                });
                this.startableByUserSlimInstance = new SlimSelect({
                    select: '#startableByUser',
                });
            });
        });

    },
    methods: {
        resetSlimSelect() {
            this.categorySlimIntsance.setSelected('')
            this.startableByUserSlimInstance.setSelected('')
        },
        getFilterCount() {
            if (this.keyRef != "")
                this.filterCount += 1;
            if (this.defNameRef != "")
                this.filterCount += 1;
            if (this.categoryRef != "")
                this.filterCount += 1;
            if (this.startableByRef != "")
                this.filterCount += 1;
            if (this.suspendedRef != "")
                this.filterCount += 1;
        },
        filterTable(e) {
            let form = $('#formIdd')
            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
                
            }
            this.key = this.keyRef;
            this.defName = this.defNameRef;
            this.category = this.categoryRef;
            this.startableBy = this.startableByRef;
            this.suspendedType = this.suspendedRef;
            this.initDefTable();
            this.filterCount = 0
            this.getFilterCount();
            $('#formIdd').closest('#drawerOverlay').removeClass("mcc-drawer--open")
            $('#formIdd').closest('#drawerOverlay').addClass("mcc-drawer--closed")
        },
        updateOrderList(filteredApplicationList) {
            this.filterData = filteredApplicationList;
            this.filterActive = true;
            this.initDefTable();

        },
        filterFunctionList(filteredRows, filterValue) {
            this.name = filterValue;
            this.initDefTable();
            this.name = "";
            return filteredRows.filter(function (f) {
                return (

                    f.name.toString().toLowerCase().includes(filterValue.toLowerCase()) ||

                    f.category.toLowerCase().includes(filterValue.toLowerCase())

                );
            })
        },

        resetFilter() {
            this.updateCall = false;
            this.filterCount = 0;
            this.key = "";
            this.keyRef = "";
            this.defName = "";
            this.defNameRef = "";
            this.category = "";
            this.categoryRef = "";
            this.startableBy = "";
            this.startableByRef = "";
            this.suspendedType = "all"
            this.suspendedRef = "all";
            localStorage.clear();
            localStorage.setItem("showedBPMTour", "true");
            this.resetSlimSelect()
            this.initDefTable();
        },
        updateTemplate() {
            let self = this;
            this.$refs.defTable
                .querySelectorAll('td [class="name-link"]')
                .forEach(btn => {
                    btn.addEventListener("click", e => {
                        let targetEle = e.target;
                        if (targetEle != null) {
                            self.setFilterDataInLocalStorage();
                            let reference = $(targetEle).attr("data-id");
                            self.$router.push(
                                self.CONTEXT_PATH + "/processengine/processdefinitions/" + reference.trim()
                            );
                        }
                    });
                });
            this.$refs.defTable
                .querySelectorAll('td [class="table-link"]')
                .forEach(btn => {
                    btn.addEventListener("click", e => {
                        let targetEle = e.target;
                        if (targetEle != null) {
                            let reference = $(targetEle).attr("data-id");
                            self.$router.push(
                                self.CONTEXT_PATH + "/processengine/deployment/" + reference.trim()
                            );
                        }
                    });
                });
        },
        initDefTable() {
            let self = this;
            if (this.tableObj != null) {
                this.currentPageSize = this.tableObj.tableContext.store.state.pageSize;
            }
            const filesTable = document.querySelector('#defTableId');
            this.tableObj = window.tableFactory.create(filesTable, {
                bordered: true,
                striped: true,
                emptyTemplate: '<p class="text-center m-0">No process definitions found</p>',
                loadingTemplate: '<p class="text-center m-0">Loading...</p>',
                columnSearch: false,
                pageSize: self.currentPageSize,
                debounceTime: 1000,
                schema: {
                    properties: {
                        key: {
                            type: "string",
                            title: "Key",
                            sortable: true,
                            columnSearch: false
                        },
                        name: {
                            type: "string",
                            title: "Name",
                            template: '<a class="name-link" data-id="{{id}}">{{name}}</a>',
                            sortable: true,
                            columnSearch: false
                        },
                        category: {
                            type: "string",
                            title: "Category",
                            sortable: true,
                            columnSearch: false
                        },
                        version: {
                            type: "string",
                            title: "Version",
                            sortable: true,
                            columnSearch: false
                        },
                        active: {
                            type: "string",
                            title: "Active",
                            sortable: false,
                            columnSearch: false
                        },
                        deploymentId: {
                            type: "string",
                            title: "Deployment ID",
                            template: '<a class="table-link" data-id="{{deploymentId}}">{{deploymentId}}</a>',
                            sortable: true,
                            columnSearch: false
                        }
                    }
                },
                data: (
                    start,
                    limit,
                    sortHeader,
                    sortDirection,
                    fullTextQuery,
                    searchColumns
                ) => {
                    if (!self.filterActive) {
                        self.updateCall = false;
                        if (self.tableObj != null) {
                            self.currentPageSize =
                                self.tableObj.tableContext.store.state.pageSize;
                        }
                        if (sortHeader == null) {
                            sortHeader = "key";
                        }
                        if (sortDirection == null) {
                            sortDirection = "asc";
                        }
                        let queryString =
                            "start=" +
                            start +
                            "&length=" +
                            self.currentPageSize +
                            "&sort=" +
                            sortHeader +
                            "&dir=" +
                            sortDirection +
                            "&name=" +
                            self.defName +
                            "&key=" +
                            self.key +
                            "&category=" +
                            self.category +
                            "&startableByUser=" +
                            encodeURI(self.startableBy) +
                            "&suspended=" +
                            encodeURI(self.suspendedType);
                        return DefinitionAPI.getProcessDefinitions(queryString).then(result => {
                            let responseData = {
                                totalCount: 0,
                                data: []
                            };
                            responseData.totalCount = result.page.totalElements;
                            if (result.data != null) {
                                responseData.data = result.data;
                            }
                            self.updateCall = true;
                            self.responseData = responseData.data;
                            self.tableData = responseData.data;
                            return responseData;
                        });
                    } else {
                        self.filterActive = false;
                        let responseData = {
                            totalCount: self.filterData.length,
                            data: self.filterData
                        };
                        return responseData;
                    }
                },
                onAfterDataLoad: (start, limit) => {
                    self.updateTemplate();
                }
            });
        },
        setFilterDataInLocalStorage() {
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_key",
                this.key
            );
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_defName",
                this.defName
            );
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_category",
                this.category
            );
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_startableBy",
                this.startableBy
            );
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_suspendedType",
                this.suspendedType
            );
        }
    }
};
</script>

<style scoped>
</style>
